import HTMLElement from '../html-element/HTMLElement.js';
/**
 * HTMLHeadingElement
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/HTMLHeadingElement
 */
export default class HTMLHeadingElement extends HTMLElement {}
